var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgDashedCircledUser = function SvgDashedCircledUser(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 50,
    height: 50,
    fill: "none",
    viewBox: "0 0 50 50"
  }, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 48,
    height: 48,
    x: 0.75,
    y: 0.75,
    stroke: "#2e3330",
    strokeDasharray: "5 7",
    strokeLinecap: "round",
    strokeLinejoin: "bevel",
    strokeWidth: 1.5,
    rx: 24
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "#2e3330",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5,
    d: "M33.25 33.75v-2a4 4 0 0 0-4-4h-8a4 4 0 0 0-4 4v2m12-14a4 4 0 1 1-8 0 4 4 0 0 1 8 0"
  })));
};
export default SvgDashedCircledUser;